import { connect } from 'react-redux';
import i18next from 'i18next';
import React from 'react';

import { showErrorMessage, showSuccessMessage } from '@actions/messageconfirmation';

import { FieldLabel, InputWrapper } from '../styledComponents';
import { IconButton } from '@mui/material';
import { Input } from '@lib/inpulse/Input';

export const UpdatePublicApiFormActionFormInput = (props) => {
  const { showErrorMessage, showSuccessMessage, selectedKey } = props;

  return (
    <>
      <FieldLabel htmlFor="apiKey">
        {i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.APIKEY_LABEL')}
      </FieldLabel>
      <InputWrapper>
        <Input id="apiKey" name="apiKey" value={selectedKey.apiKey} readOnly />
        <IconButton
          sx={{
            position: 'absolute',
            right: 16,
            top: '35%',
            transform: 'translateY(-50%)',
            padding: 0,
          }}
          onClick={() =>
            navigator.clipboard
              .writeText(selectedKey.apiKey)
              .then(() => {
                showSuccessMessage(i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.COPY_SUCCESS'));
              })
              .catch(() => {
                showErrorMessage(i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.COPY_FAILURE'));
              })
          }
        >
          <img alt="copy" height={16} src="/images/inpulse/content-copy.svg" width={16} />
        </IconButton>
      </InputWrapper>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showErrorMessage: (message) => dispatch(showErrorMessage(message)),
  showSuccessMessage: (message) => dispatch(showSuccessMessage(message)),
});

export default connect(null, mapDispatchToProps)(UpdatePublicApiFormActionFormInput);
